import { PublicClient } from 'viem';

export type ReadRetryOptions<T> = {
  /** total attempts, including the first one (default varies by chain) */
  attempts?: number;
  /** initial delay between attempts in ms (default varies by chain) */
  delayMs?: number;
  /** backoff multiplier applied to delay after each failure (default 1.8) */
  backoff?: number;
  /** add ±jitterMs randomization to each delay (default 150) */
  jitterMs?: number;
  /**
   * Optional validator for returned value.
   * If provided and returns false, we’ll treat it as retryable.
   */
  validate?: (value: T) => boolean;
  /**
   * Extra clients to try if the primary client keeps failing (optional).
   * We’ll exhaust all attempts on the primary, then try fallbacks sequentially.
   */
  fallbacks?: PublicClient[];
};

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

export function isRetryableError(e: unknown): boolean {
  const msg = (e as any)?.message?.toString()?.toLowerCase() ?? '';
  // common provider/RPC transient errors
  return (
    msg.includes('rate limit') ||
    msg.includes('429') ||
    msg.includes('timeout') ||
    msg.includes('timed out') ||
    msg.includes('socket hang up') ||
    msg.includes('econnreset') ||
    msg.includes('gateway') || // 502/504 gateway errors
    msg.includes('context deadline exceeded') ||
    msg.includes('header not found') || // base/alchemy sporadic
    msg.includes('no data') ||
    msg.includes('returned no data') ||
    msg.includes('failed to fetch') ||
    msg.includes('temporarily unavailable') ||
    msg.includes('deadline') ||
    msg.includes('too many requests')
  );
}

export function defaultsForChain(client: PublicClient) {
  // const id = client.chain?.id;
  const id = 8453;
  // Base mainnet 8453 / Base Sepolia 84532 tend to need slightly more patience
  const isBase = id === 8453 || id === 84532;
  return {
    attempts: isBase ? 6 : 4,
    delayMs: isBase ? 250 : 150,
    backoff: 1.8,
    jitterMs: 150,
  };
}
